import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { EnrollmentReviewsResponse } from './types'

export function getEnrollmentEndOfJourneyReviews(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEndOfJourneyReviews.url, { id: enrollmentId }))
    .get<EnrollmentReviewsResponse>()
}
